var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"BSCTag",class:[`is-${_vm.type}`, { 'is-deletable': _vm.deletable }],on:{"click":_vm.clickTag}},[_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.deletable)?_c('BSCIcon',{staticClass:"BSCTag-delete",attrs:{"icon":"deleteIcon"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }